import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { Overline, Rule, Watermark } from "@/components/site/Primitives";

export default function LegalPage({ which }) {
  const [legal, setLegal] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then((r) => setLegal(r.data.legal)).catch(() => {});
  }, []);

  const title = which === "privacy" ? "Privacy Policy" : "Terms of Use";
  const body = which === "privacy" ? legal?.privacy : legal?.terms;

  return (
    <>
      <Seo title={title} description={`${title} for the Goldman Fischer website.`} />
      <section className="relative overflow-hidden border-b border-gold-500/20 bg-cream-200/40">
        <Watermark className="-right-6 top-0 text-[11rem]">{which === "privacy" ? "Privacy" : "Terms"}</Watermark>
        <div className="relative mx-auto max-w-4xl px-5 py-16 lg:px-10">
          <Overline>Legal</Overline>
          <h1 className="mt-4 font-serif text-5xl font-light text-ink">{title}</h1>
          <Rule className="mt-6" />
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-5 py-16 lg:px-0">
        {body ? (
          <div className="font-sans text-base leading-relaxed text-steel-700 whitespace-pre-line">{body}</div>
        ) : (
          <p className="text-steel-500">Loading…</p>
        )}
      </section>
    </>
  );
}
